import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./calcite-date-picker.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./calcite-date-picker.component.css?ngResource";
import { Component } from '@angular/core';
let CalciteDatePickerComponent = class CalciteDatePickerComponent {
    constructor() { }
    ngOnInit() {
    }
    static ctorParameters = () => [];
};
CalciteDatePickerComponent = __decorate([
    Component({
        selector: 'lib-calcite-date-picker',
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CalciteDatePickerComponent);
export { CalciteDatePickerComponent };
